import { requestApi } from "../funcitons";

export const PagesQueries = {
    createPage: async (projectId, name) => {
        const res = await requestApi('pages', 'POST', { project_id: projectId, name });
        return res.data;
    },
    updatePage: async (pageId, name, background_type, background_color, background_image_uri, background_video_uri) => {
        const res = await requestApi('pages/' + pageId, 'PUT', { name, background_type, background_color, background_image_uri, background_video_uri });
        return res.data;
    },
    deletePage: async (pageId) => {
        const res = await requestApi('pages/' + pageId, 'DELETE');
        return res.data;
    },
    getAllPages: async (projectId) => {
        const res = await requestApi('pages?project_id=' + projectId, 'GET');
        return res.data;
    },
};

export default PagesQueries;